import CMSection from '@src/components/Atoms/CMSection';
import { devices } from '@src/styles/theme';
import { checkSponserClick } from '@src/utils/gtag';
import Image from 'next/image';
import styled from 'styled-components';

const Last = () => {
  const sponserLink = () => {
    checkSponserClick();
    window.open('https://www.ihappynanum.com/Nanum/B/R4SC5RTHBP', '_blank');
  };
  return (
    <CMSection>
      <Wrap>
        <LastImage
          width={1920}
          height={763}
          src={'/imgs/sponser/last.svg'}
          alt="image"
        />
        <LastMbImage
          width={1920}
          height={763}
          src={'/imgs/sponser/last-mb.svg'}
          alt="image"
        />
        <Text>
          피플에 후원하고 많은 환자분들께
          <br />
          생명을 전해주세요
        </Text>
        <Button onClick={sponserLink}>후원하기</Button>
      </Wrap>
    </CMSection>
  );
};

const Wrap = styled.div`
  position: relative;
  /* height: 755px; */
`;

const LastImage = styled(Image)`
  display: block;
  @media ${devices.tablet} {
    display: none;
  }
`;

const LastMbImage = styled(Image)`
  display: none;
  @media ${devices.tablet} {
    display: block;
    width: 100%;
    height: 100%;
  }
`;

const Text = styled.div`
  color: ${({ theme }) => theme.commonColor.white};
  text-align: center;
  font-family: 'NOTO';
  font-size: 47px;
  font-style: normal;
  font-weight: 600;
  line-height: 65px; /* 138.298% */
  letter-spacing: -1.41px;
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  white-space: pre-wrap;
  width: 100%;
  @media ${devices.tablet} {
    font-size: 24px;
    font-weight: 500;
    line-height: 36px; /* 150% */
    letter-spacing: -0.72px;
    top: 40%;
  }
`;

const Button = styled.button`
  border-radius: 40.5px;
  background: ${({ theme }) => theme.commonColor.pink004};
  padding: 20px 76px;
  margin-top: 40px;
  position: absolute;
  bottom: 20%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  color: ${({ theme }) => theme.commonColor.white};
  text-align: center;
  font-family: 'Regular';
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px; /* 115.385% */
  letter-spacing: -0.6px;
  width: 300px;

  @media ${devices.tablet} {
    width: 150px;
    padding: 6px 20px;
    font-size: 16px;
    line-height: 24px; /* 150% */
    bottom: 15%;
    border-radius: 32px;
  }
`;

export default Last;
